import { WarningOutlined } from '@ant-design/icons';
import { typographyStyle, Flex } from '@revenuemarket/cds';
import { semanticColors, theme } from '@revenuemarket/design';
import { overlays } from '@revenuemarket/overlays';
import { CUSTOM_ATTRIBUTES } from '@revenuemarket/utils';
import { Typography } from 'antd';

import { SCRAPE_STATUS } from '~apis/scrape';
import { getTimeText } from '~utils/date';

import ScrapeStatusDrawer from './ScrapeStatusDrawer';

const IconForStatus = ({ status }: { status?: SCRAPE_STATUS }) => {
  switch (status) {
    case 'ERROR':
    case 'FATAL':
      return (
        <WarningOutlined
          style={{
            color: semanticColors.danger.regular,
          }}
        />
      );

    default:
      return <div />;
  }
};

const TextForStatus = ({ scrapeTime, status }: { scrapeTime?: string; status?: SCRAPE_STATUS }) => {
  const textForNotScraped = '수집 기록 없음';
  const commonStyle = {
    width: 'max-content',
    color: theme.colorTokens.textDescription,

    maxWidth: 110,
    ...typographyStyle['13_400'],
  };
  switch (status) {
    case 'SUCCESS':
      return (
        <Typography.Text style={{ ...commonStyle, textDecoration: 'underline' }} ellipsis>
          {scrapeTime ? `${getTimeText(scrapeTime)} 수집 완료` : textForNotScraped}
        </Typography.Text>
      );
    case 'ERROR':
    case 'FATAL':
      return (
        <Typography.Text style={commonStyle} ellipsis>
          {scrapeTime ? `${getTimeText(scrapeTime)} 수집 오류` : textForNotScraped}
        </Typography.Text>
      );
    case 'IN_PROGRESS':
      return (
        <Typography.Text style={{ ...commonStyle, textDecoration: 'underline' }} ellipsis>
          방금 전
        </Typography.Text>
      );
    default:
      return (
        <Typography.Text style={commonStyle} ellipsis>
          {textForNotScraped}
        </Typography.Text>
      );
  }
};

const CollectionStatusText: React.FC<{ scrapeTime?: string; status?: SCRAPE_STATUS }> = ({
  scrapeTime,
  status,
}) => {
  return (
    <Flex
      style={{
        cursor: 'pointer',
      }}
      onClick={() => {
        overlays.open(({ isOpen, onClose }) => (
          <ScrapeStatusDrawer isOpen={isOpen} onClose={onClose} />
        ));
      }}
      {...CUSTOM_ATTRIBUTES.NAVIGATION_BODY.COLLECTION_STATUS_TEXT(getTimeText(scrapeTime), status)}
    >
      <Flex gap={4} align="center">
        {scrapeTime != null && <IconForStatus status={status} />}

        <TextForStatus status={status} scrapeTime={scrapeTime} />
      </Flex>
    </Flex>
  );
};

export default CollectionStatusText;
